import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
    routes: [
        {
            path: '*',
            redirect: '/api/Example'
        },
        // {
        //     path: '/Home',
        //     name: 'Home',
        //     component: () => import("./views/Home"),
        //     meta: {title: "主页", name: "主页"}
        // },


        {
            path: '/api/Example',
            name: 'Example',
            component: () => import("./views/api/Example"),
            meta: {
                title: "加密与请求实例",
                name: "加密与请求实例",
            }
        },
        {
            path: '/api/GetDevData',
            name: 'GetDevData',
            component: () => import("./views/api/GetDevData"),
            meta: {
                title: "获取设备历史数据接口",
                name: "获取设备历史数据接口",
            }
        },
        {
            path: '/api/ListDevStatusBySN',
            name: 'ListDevStatusBySN',
            component: () => import("./views/api/ListDevStatusBySN"),
            meta: {
                title: "获取设备实时状态接口",
                name: "获取设备实时状态接口",
            }
        },
        {
            path: '/api/GetDevList',
            name: 'GetDevList',
            component: () => import("./views/api/GetDevList"),
            meta: {
                title: "获取设备列表接口",
                name: "获取设备列表接口",
            }
        },


        {
            path: '/formdemo',
            name: 'formdemo',
            component: () => import('./views/demo/formdemo.vue'),
            meta: {
                title: '表单',
                name: '表单',
                array: [{name: '主页', path: '/home'}, {name: '表单', path: '/formdemo'}]
            }
        },
        {
            path: '/tabledemo',
            name: 'tabledemo',
            component: () => import('./views/demo/tabledemo.vue'),
            meta: {
                title: '列表',
                name: '列表',
                array: [{name: '主页', path: '/home'}, {name: '列表', path: '/tabledemo'}]
            }
        },

    ]
})
